import React from 'react';
import Chart from 'react-apexcharts';
import { useTheme } from '@mui/material/styles';
import { Stack, Typography, Avatar } from '@mui/material';
import { IconArrowUpRight } from '@tabler/icons';
import DashboardCard from '../../shared/DashboardCard';

const TotalBookings = ({ totalBookings }) => {
  const theme = useTheme();
  const secondary = theme.palette.secondary.main;
  const secondarylight = theme.palette.secondary.light;
  const successlight = theme.palette.success.light;

  const optionscolumnchart = {
    chart: {
      type: 'area',
      fontFamily: "'Plus Jakarta Sans', sans-serif;",
      foreColor: '#adb0bb',
      toolbar: { show: false },
      height: 80,
      sparkline: { enabled: true },
      group: 'sparklines',
      events: {
        mouseMove: () => false,
        mouseLeave: () => false
      }
    },
    stroke: { curve: 'smooth', width: 2 },
    fill: { colors: [secondarylight], type: 'solid', opacity: 0.05 },
    markers: { size: 0 },
    tooltip: {
      enabled:false,
      theme: theme.palette.mode === 'dark' ? 'dark' : 'light',
      x: { show: false },
    },
  };
  const seriescolumnchart = [{ name: '', color: secondary, data: [30, 25, 35, 20, 30, 40] }];

  return (
    <DashboardCard 
    // footer={<Chart options={optionscolumnchart} series={seriescolumnchart} type="area" height="30px" 
    // />}
    >
      <>
        <Typography variant="h6" color="textSecondary">Total Bookings</Typography>
        <Typography variant="caption" color="textSecondary" sx={{ display: 'block', mt: 0.5 }}>
          All Time
        </Typography>
        <Stack direction="row" spacing={1} my={1} alignItems="center">
          <Typography variant="h5">{totalBookings}</Typography>
          <Avatar sx={{ bgcolor: successlight, width: 24, height: 24 }}>
            <IconArrowUpRight width={18} color="#39B69A" />
          </Avatar>
          {/* <Typography variant="subtitle2" fontWeight="600">+9%</Typography> */}
        </Stack>
      </>
    </DashboardCard>
  );
};

export default TotalBookings;